import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import css from './index.scss'
import logoPurple from '../../../../assets/img/logo-azship-purple.svg'

const PendingLoading = (props) => {
  const [isApplicationLoading, setIsApplicationLoading] = useState(false)
  const applicationLoading = useSelector(state => state.pendings.isApplicationLoading)

  useEffect(() => {
    setIsApplicationLoading(applicationLoading)
  }, [applicationLoading])

  if (isApplicationLoading && 'loading' in props) {
    return null
  }
  if (!isApplicationLoading) {
    return null
  }

  return (
    <div className={props.loading ? css.sectionLoading : css.container}>
      <div className={props.loading ? css.sectionLoader : css.loaderContainer}>
        <img src={logoPurple} alt="logo" className={css.logoLoader} />
        <div className={css.loader} />
      </div>
    </div>
  )
}

export default PendingLoading
